<template>
  <div class="container">
    <!-- Header -->
    <Header></Header>
    <!-- 主内容 -->
    <div class="newstxtbox">
      <div class="content">
        <div class="ny_nr">
          <div class="ny_lm">
            <div class="ny_bt">
              <h4><i>C</i>LASSIC CASE</h4>
              <h1>客户案例</h1>
            </div>
            <div class="ny_ej">
              <ul>
                <li v-for="(item,index) in cateList"><a href="javascript:;" :class="[cid == item.id?'cur':'']" @click="changeCate" :data-cid="item.id" :data-catename="item.name">{{item.name}}</a></li>
              </ul>
            </div>
          </div>
          <div class="ny_wz">
            <h3>{{cate_name}}</h3>
            <em></em>
          </div>
          <div class="ny_qy">
            <div class="xw_lb">
              <ul>
                <li v-for="(item,index) in list">
                  <div class="row">
                    <div class="news-left">
                      <div class="t_p">
                        <a href="javascript:;" @click="casesDetail" :data-id="item.id">
                          <!-- <img :src="base_url+item.imgUrl" /> -->
                          <img src="/static/images/news/news.jpg" />
                        </a>
                        </div>
                    </div>
                    <div class="news-right">
                      <div class="w_z">
                        <h3><a href="javascript:;" @click="casesDetail" :data-id="item.id">{{item.title}}</a></h3>
                        <p>{{item.brief}}</p>
                        <span><i class="fa fa-clock-o"></i>{{item.addTime}}</span> <a href="javascript:;" class="x_q" @click="casesDetail" :data-id="item.id">查看详情 +</a>
                        <div class="clear"></div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <!-- 分页 -->
          </div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
  import axios from 'axios';
  var CONFIG = require('@/common/config.js');
  var base_url = CONFIG.API_URL.BASE_URL;

  //分页信息
  var page = 1;
  var limit = 8;

  //加载数据
  var GetList = function (that, orbottom) {
  	//data数据
  	var data = {
  		'page': page,
  		'limit': limit,
  		'type': 3,
      'cate_id': that.cid,
  	}
  	//请求数据
    axios.post(base_url+'front/pagingInfo', data).then(function (res) {
      //console.log(res);
      if(res.data.code == 0){
        var dataList = res.data.result.records;
        var total = res.data.result.total;
        var list = orbottom == 1 ? that.list : [];
        //for循环数据
        for (var i = 0; i < dataList.length; i++) {
          list.push(dataList[i]);
        }
        //渲染页面数据
        that.list = list;
      }
    }).catch(function (err) {
      //console.log(err);
    })
  }

  export default {
    data () {
      return {
        base_url: base_url,//base_url
        cateList: [],//分类列表
        cid: 0,//分类id
        cate_name: '',//分类名称
        list: [],//列表
      }
    },
    created: function () {
      var that = this;

      //获取资讯分类
      that.getCateList();
    },
    methods: {
      //获取资讯分类
      getCateList:function(){
        var that = this;
        axios.post(base_url+'front/getInfoCateList', {'type': 3}).then(function (res) {
          //console.log(res);
          if(res.data.code == 0){
            var dataList = res.data.result;
            that.cateList = dataList;
            that.cid = dataList[0]['id'];
            that.cate_name = dataList[0]['name'];

            //获取分页数据
            GetList(that,0);
          }
        }).catch(function (err) {
          //console.log(err);
        })
      },

      //切换分类
      changeCate:function(e){
        var that = this;
        var cid = e.currentTarget.dataset.cid;
        var cate_name = e.currentTarget.dataset.catename;
        that.cid = cid;
        that.cate_name = cate_name;

        //获取分页数据
        page = 1;
        that.list = [];
        GetList(that,0);
      },

      //案例详情
      casesDetail:function(e){
        var that = this;
        var id = e.currentTarget.dataset.id;
        that.$router.push({ path: '/casesDetail?id='+id });
        //储存导航标识
        localStorage.setItem("navIndex","4");
      },


    }
  }
</script>

<style>
  @import url("./cases.css");
</style>



// WEBPACK FOOTER //
// src/views/cases/cases.vue